import { yupResolver } from "@hookform/resolvers/yup";
import { Button, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { useTenant } from "../../providers/tenant";
import { useUser } from "../../providers/users";
import Loading from "../Loading";
import { Container } from "./styles";

const FindTenantForm = () => {
  const { apiLoading } = useUser();
  const { getTenantByPath } = useTenant();

  const { t } = useTranslation();
  const formSchema = yup
    .object()
    .shape({
      path: yup.string().required(t("tenant_path_required")),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });
  type FormValues = yup.InferType<typeof formSchema>;
  const onSubmit = async (data: FormValues) => {
    await getTenantByPath(data);
  };

  return (
    <Container onSubmit={handleSubmit(onSubmit)}>
      <p className="tenantFindMessage">{t("tenant_find_message")}</p>
      <TextField
        error={errors.path === undefined ? false : true}
        helperText={errors.path?.message?.toString()}
        id="standard-path"
        label={t("tenant_path")}
        variant="filled"
        InputProps={{
          disableUnderline: true,
        }}
        sx={{
          boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",

          textAlign: "center",
          backgroundColor: "#FFF",
          "& fieldset": { border: "none" },
        }}
        {...register("path")}
      />

      {apiLoading ? (
        <Loading />
      ) : (
        <Button variant="contained" type="submit" size="large">
          {t("confirm")}
        </Button>
      )}
    </Container>
  );
};

export default FindTenantForm;
